<template>
    <div id="editorWrapper">
        <h2>{{title}}</h2>
        <button @click="requestReport">отправить данные для отчёта</button>
        <button @click="loadTemplate">загрузить</button>
        <input type="text" v-model="searchStr" @change="filterTable"/>
        <div id="editor" class="unselectable"></div>


        <div class="editor-context-menu">
            <div class="cm__item">Добавить из справочника</div>
            <div class="cm__divider"></div>
            <div class="cm__item" v-on:click="deleteRecord">Удалить</div>
            <div class="cm__item" v-on:click="clearTable">Очистить таблицу</div>
        </div>

        <excel-viewer ref="excelViewer"/>
    </div>    
</template>


<script>
import excelViewer from "@/components/excelViewer"
let editor = null;
export default {
    name:'editor',
    props: {
        title: ''
    },
    components:{excelViewer},
    data: function () {
           return {
               editor: null,
               projectId: null,               
               selectedRow: null,
               projectParams: {
                   nds: 20,
                   workHoursPerMonth: 164.17,
                   avgSalary: 25000,
                   object: 'объект ------- ',
                   objectAddr: 'адрес объекта ------- ',
                   client: 'наименование заказчика',
                   worker: 'наименование подрядчика'
               },
               reportReady: false,
               reportPath: null,
               category: [],
               subcategory: [],
               searchStr: ''
               //editorData: []
            }
     }, 

    watch: {
//       getTableData: { handler: function (newData) { if (this.editor) { this.editor.replaceData(newData); console.log('replacing data'); } } , deep: false }
    },

    computed:{
        getTableData(){ return this.$store.state.editorData; },
        tableTotals() {
            
        }
    },
    
    methods:{
        customFilter(data, filterParams){
            //if data.title 
            var found = false;
            if (data.title.indexOf(this.searchStr) !== -1) {found = true;};
            if (data.cipher.indexOf(this.searchStr) !== -1) {found = true;};
            console.dir('filter');
            console.dir(data);

            var children = data._children;
            if (children) {
                if (children[0].title.indexOf(this.searchStr) !== -1) {found = true;};
                if (children[0].cipher.indexOf(this.searchStr) !== -1) {found = true;};
            }

            return found;
            //return data.title == this.searchStr && data.height < filterParams.height; //must return a boolean, true if it passes the filter.
        },
        filterTable(){
            this.editor.setFilter(this.customFilter, {searchStr:this.searchStr});
        },
        loadTemplate(){
            const self = this;

      
        this.$axios.post('http://xlsgen.ddns.net/api/jrecords.json')
            .then(function (response) {
                let data = response.data;
                self.editor.setData(data);
                console.dir('table axios');
                console.dir(response.data);
            }).catch(function (error) {
                console.log(error);
            });
        },
        

        requestReport(){
             //JSON.stringify(
            console.log('request report');
            //{ tableData: this.$store.state.editorData }
            const self = this;
            let log = document.getElementById("grid_toolbar");
            //this.$axios.post('http://xlsgen.ddns.net/xlsgen_req.php', 
            self.$refs.excelViewer.show();
            self.$refs.excelViewer.isLoading = true;
            this.$axios.post('http://xlsgen.ddns.net/api/core.php', 
             { 
                 data: '11111111',
                 projectId: 1,
                 projectOptions: 2,
                 projectData: 3,
                 projectParams: self.projectParams,
                 projectAutoFillData: 4,
                 tableData: this.editor.getData() 
              }
             )
             .then(function (response) {
                console.dir(log);
                log.innerHTML = response.data;
                var reportFileName = response.data.reportPath;
                console.log(response.data.reportPath);
                console.log(response.data.reportType);
                console.dir(response.data);
                
                //self.$refs.excelViewer.setUrl('http://xlsgen.ddns.net/tmp/report_.xlsx')
                //self.$refs.excelViewer.setUrl('http://xlsgen.ddns.net/tmp/getfile.php?file=report_.xlsx')
                self.$refs.excelViewer.setUrl('http://xlsgen.ddns.net/api/reports_tmp/', reportFileName)
                //self.$refs.excelViewer.requestViewer('http://xlsgen.ddns.net/api/reports_tmp/', reportFileName)                
                self.$refs.excelViewer.isLoading = false;
                //self.$refs.excelViewer.show();
                //console.log(response);
            }).catch(function (error) {
                self.$refs.excelViewer.close();
                console.log(error);
            });
            //@json_decode(($stream = fopen('php://input', 'r')) !== false ? stream_get_contents($stream) : "{}");
            //$_POST = array_merge($_POST, (array) json_decode(file_get_contents('php://input')));
        },
        showContextMenu(e, row){
            const cm = document.querySelector(".editor-context-menu");
            //  e.preventDefault();
//            function showMenu(show = true) {  cm.style.display = show ? "block" : "none";  }
//            window.addEventListener("contextmenu", e => { preventDefault(); 
//                showMenu();
                console.dir(e.y);   row.select();  this.selectedRow = row;
                let posX = e.x + cm.offsetWidth > window.innerWidth ? window.innerWidth - cm.offsetWidth : e.x;
                let posY = e.y + cm.offsetHeight > window.innerHeight ? window.innerHeight - cm.offsetHeight : e.y;              
                cm.style.left = posX +'px' //+ cm.offsetWidth > window.innerWidth ? window.innerWidth - cm.offsetWidth : e.x;
                cm.style.top = posY +'px' //+ cm.offsetHeight > window.innerHeight ? window.innerHeight - cm.offsetHeight : e.y;
                if (cm) {
                //cm.style.background = "#000";
                    cm.style.display = "block";//"none" ? "block" : "none";
                }
//            });

            if (window) {
                window.addEventListener("click", () => {
                 //showMenu(false);
                    const cm = document.querySelector(".editor-context-menu");
                    cm.style.display = "none";
                    e.preventDefault();
                });
            }

            e.preventDefault();
        },
        buildReport (){
            console.dir('build report')
        },
        clearTable(){
            console.dir('clear editor table ');
            this.editor.clearData();
            //let data = this.getTableData;
            //this.$store.clearEditor;
            this.$store.dispatch('clearEditor');
        },
        deleteRecord(id){
            console.dir('delete record ' + id);             
             const tableData = this.getTableData;
             const rowid = this.selectedRow.getData().id;
             //if (tableData.length > 0) { index = tableData.findIndex((e) => e.id === id);  }
             //tableData[index].delete;
             this.selectedRow.delete();
        },
        addRecord(rowData){
            console.dir('add record ' + rowData)
        },
        addOrUpdateRecord(rowData){
                const tableData = this.getTableData;//$store.state.editorData;
                console.dir(tableData);
                let index = -1;
                if (tableData.length > 0) { index = tableData.findIndex((e) => e.id === rowData.id);  }
//                const index = tableData.findIndex((e) => e.id === rowData.id);
                if (index === -1) {
                    rowData.qty = 1;
                    tableData.push(rowData);
                    this.editor.addData(rowData);
                } else {                    
                    tableData[index].qty = parseFloat(tableData[index].qty) + 1;
                    this.editor.updateData([ { id:tableData[index].id, qty:tableData[index].qty } ]);
                }

        }, 
        rowReceiver(fromRow, toRow, fromTable){
             console.log('ROW RECEIVED');
             let rowData = fromRow.getData();
             let qty = parseFloat(rowData.qty) + 1;
             let table = this.editor;
             console.dir(rowData);
             this.addOrUpdateRecord(rowData);
             //table.addOrUpdateData({})
             
             
               //  if(toRow){
              //      toRow.update({"name":fromRow.getData().name});
             //       return true;
            //    } 
            return true;
        }
    },
    created(){
        console.log('EDITOR created '+ this.editor);
        const self = this;
        this.$axios.get('http://xlsgen.ddns.net/api/categories.json')
        .then(function (response) {
            self.category = response.data;
            console.dir( self.category);
        });
        this.$axios.get('http://xlsgen.ddns.net/api/subcategories.json')
        .then(function (response) {
            self.subcategory = response.data;
            console.dir( self.subcategory);
        });          
    },
    
    beforeMount(){

    },

    mounted() { //instantiate Tabulator when element is mounted     
      console.log('EDITOR MOUNTED');
      const editor = this;
      const self = this;
      let editorData = this.$store.state.editorData;
      this.editor = new Tabulator('#editor', {
      //data: editor.getTableData,
      data: editorData,      
      //data: this.editorData, //link data to table
      //movableRowsReceiver: "add",
      movableRowsReceiver: this.rowReceiver,
      selectable: 1,
      tableContext:this.showContextMenu,
      rowContext:this.showContextMenu,
      placeholder:"Начните заполнять таблицу",
      columnVertAlign:"middle", //align header contents to bottom of cell
	  columnAlign:"center", 
      groupBy:["cat","subcat"],
      groupToggleElement:"header",
      groupStartOpen:[true, true],
      dataTree:true,
      dataTreeStartExpanded:true,
       dataTreeBranchElement:true,
       dataTreeChildIndent:25,
      // dataTreeCollapseElement:"<i class='fas fa-minus-square'></i>",
      layout:"fitColumns",
      rowMoved:function(row){
          console.log('row moved');
          console.dir('row');
      },
      rowAdded:function(row){
          console.log('row added');
          console.dir('row');
          editor.addRecord(row.getData());
      },
      rowUpdated:function(row){
          console.log('row updated');
          console.dir('row');
      },
      //height: "500px",
      height: "calc(100vh - 10rem)",
      groupHeader:[
        function(value, count, data){ //generate header contents for top groups
	 		 // console.log(value);
          //console.dir(data);
          //console.dir(self.category);
          //return 'aaa'; //self.category;        
		  return self.category[value-1].title;
		  //+ "<span style='color:#888; margin-left:10px;'>(" + count + " элем.)</span>";
            },
        function(value, count, data){ //generate header contents for sub group
        //return 'bbb'; 
        return "<label style=''>" + self.subcategory[value-1].title + "</label>";
		//<span style='color:#888; margin-left:10px;'>(" + count + " элем.)</span>";
        //return value + "<span style='color:#fff; margin-left:10px;'>(" + count + " элем.)</span>";		  
            },
	    ],

      columns: [
//          { title: "#",     field: "id",     width: 40, headerSort:false, visible:true, align:"center", formatter:"rownum", resizable:false},
//          { title: "rowId", field: "id",     width: 10, headerSort:false, visible:false, resizable:false},
//	      { title: "cat",   field: "cat",    width: 0,  headerSort:false, visible:false, resizable:false},
//	      { title: "subcat",field: "subcat", width: 0,  headerSort:false, visible:false, resizable:false},          
          { title: "Шифр",  field: "cipher", width: 80, align:"center", headerSort:false},
          { title:"Наименование", field:"title",  width:500, align:"left", headerSort:false, formatter:"textarea"},
          { title:  "Кол-во.",      field:"qty",    width:80, align:"right", editor:true, editor:"number", headerSort:false,
            editorParams:{min:0, max:1000000, step:1}, formatter:"money",  formatterParams:{decimal:",", thousand:"", precision:0},
          },
          
          // column group
          {title:"Базовые трудозатраты",
            columns:[{title:"Инженер", field:"base_engin", align:"right", headerSort:false, width:80, visible:true},
                    {title:"Техник", field:"base_tech", align:"right", headerSort:false, width:80, visible:true},],
          },
          
          // column group
          {title:"Повыш. коэфф.",
           columns:[{title:"Инженер", field:"koeff_engin", align:"right", headerSort:false, width:80,visible:true},
                   {title:"Техник", field:"koeff_tech", align:"right", headerSort:false, width:80,visible:true},],
          },	 
           
          // column group
          { title:"Трудозатраты на <br/> ед. измер, (чел-час)",
		   align:"center",
           columns:[
            {title:"Инженер", field:"trud_engin", align:"right", headerSort:false, width:80, visible:true,
			    formatter:function(cell, formatterParams){
				    var row = cell.getRow();
				    var cells = row.getData();
				    var qty = cells.qty;
				    var base_engin = cells.base_engin;
				    var koeff_engin = cells.koeff_engin;
				    var value = xlRound( base_engin * koeff_engin + epsilon , 2); 				  
				    if (!isNumber(value)) {value = 0;}
				    return value;  
				//return localNumFormatter.format( parseFloat(value) ); 
				}	  
		    },
            {title:"Техник", field:"trud_tech", align:"right", headerSort:false, width:80, visible:true,
		        formatter:function(cell, formatterParams){
				    var row = cell.getRow();
				    var cells = row.getData();
				    var qty = cells.qty;
				    var base_tech = cells.base_tech;
				    var koeff_tech = cells.koeff_tech;
				    var value = xlRound(base_tech * koeff_tech + epsilon , 2);
				    if (!isNumber(value)) {value = 0;}
				    return value;  
				    //return localNumFormatter.format( parseFloat(value) ); 
				    }	  
		        },
              ],
            },	




        ],
     }
     
     );
        this.$store.state.editor = this.editor;
    }
 }
</script>


<style>


.tabulator .tabulator-header {
    border-bottom: 1px solid #ccc;
    background-color: #f5f5f5;
    color: #444;
    font-weight: 400;
}

.tabulator .tabulator-header .tabulator-col {
    border-right: 1px solid #ccc;
    background: transparent;
}

.tabulator .tabulator-header .tabulator-col[tabulator-field='title'] .tabulator-col-content{
    /* top: 50%;
     transform: translateY(-50%); */
}

.tabulator .tabulator-header .tabulator-col[tabulator-field='qty'] .tabulator-col-content{
    /* top: 50%;
     transform: translateY(-50%); */
}

.tabulator .tabulator-header .tabulator-col[tabulator-field='cipher'] .tabulator-col-content{
    /* top: 50%;
     transform: translateY(-50%); */
}


.tabulator .tabulator-header .tabulator-col .tabulator-col-group-cols .tabulator-col-content{
    /* top: 50%;
     transform: translateY(-50%); */
}


.tabulator .tabulator-header .tabulator-col .tabulator-col-content{
    margin: auto;

  /* position: absolute; */
  /* top: 50%; */
  /* transform: translateY(-50%); */
}
.tabulator .tabulator-header .tabulator-col:after{
    vertical-align: bottom;
    content: '';
}
.tabulator .tabulator-header .tabulator-col {
    /* display: table-cell; */
    vertical-align: middle;
    /* height: auto !important; */
    /* justify-items: center;
    align-items: self-end; */
}



.tabulator .tabulator-header .tabulator-col.tabulator-col-group .tabulator-col-group-cols {
    /*display: -ms-flexbox;
    display: flex; */
    border-top: 1px solid #ccc;
}

.tabulator-row .tabulator-cell {
    padding: 6px 4px 6px 6px;
    vertical-align: middle;
    border-right: 1px solid #ccc;
}


.tabulator-row .tabulator-cell .tabulator-data-tree-control {
    align-items: center;
    height: 13px;
    width: 13px;
    margin-right: 5px;
    border: 1px solid #aaa;
    border-radius: 1px; 
    overflow: hidden;
    vertical-align: baseline;
}


.tabulator-row .tabulator-cell .tabulator-data-tree-branch {
    border-left: 1px solid #aaa;
    border-bottom: 1px solid #aaa;
}
</style>